import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';

// Function to create a projector sprite (camera/projector icon) as HTML overlay
export const createProjectorSprite = () => {
  const defaultColor = '#ff6df0'; // Magenta to match projector beam color
  const hoverColor = '#ffffff';

  // Create SVG icon instead of canvas for crisper rendering
  const div = document.createElement('div');
  div.style.width = '32px';
  div.style.height = '32px';
  div.style.pointerEvents = 'auto'; // Enable clicks
  div.style.cursor = 'pointer';
  div.style.userSelect = 'none';

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '32');
  svg.setAttribute('height', '32');
  svg.setAttribute('viewBox', '0 0 32 32');
  svg.style.display = 'block';

  // Projector body
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', '4');
  rect.setAttribute('y', '10');
  rect.setAttribute('width', '18');
  rect.setAttribute('height', '12');
  rect.setAttribute('rx', '2');
  rect.setAttribute('fill', 'none');
  rect.setAttribute('stroke', defaultColor);
  rect.setAttribute('stroke-width', '2');

  // Lens
  const circle1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle1.setAttribute('cx', '20');
  circle1.setAttribute('cy', '16');
  circle1.setAttribute('r', '4');
  circle1.setAttribute('fill', 'none');
  circle1.setAttribute('stroke', defaultColor);
  circle1.setAttribute('stroke-width', '2');

  const circle2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle2.setAttribute('cx', '20');
  circle2.setAttribute('cy', '16');
  circle2.setAttribute('r', '1.5');
  circle2.setAttribute('fill', defaultColor);

  svg.appendChild(rect);
  svg.appendChild(circle1);
  svg.appendChild(circle2);
  div.appendChild(svg);

  const sprite = new CSS2DObject(div);
  sprite.center.set(0.5, 0.5);

  sprite.userData.isHovered = false;
  sprite.userData.updateColor = (isHovered) => {
    sprite.userData.isHovered = isHovered;
    const color = isHovered ? hoverColor : defaultColor;
    rect.setAttribute('stroke', color);
    circle1.setAttribute('stroke', color);
    circle2.setAttribute('fill', color);
  };

  return sprite;
};

// Function to create a circular target sprite as HTML overlay
export const createTargetSprite = () => {
  // Default colors
  const defaultColor = '#a21caf';
  const hoverColor = '#ffffff';

  // Create SVG target icon
  const div = document.createElement('div');
  div.style.width = '24px';
  div.style.height = '24px';
  div.style.pointerEvents = 'none'; // Disable clicks
  div.style.cursor = 'pointer';
  div.style.userSelect = 'none';

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '24');
  svg.setAttribute('height', '24');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.style.display = 'block';

  // Outer circle
  const outerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  outerCircle.setAttribute('cx', '12');
  outerCircle.setAttribute('cy', '12');
  outerCircle.setAttribute('r', '9');
  outerCircle.setAttribute('fill', 'none');
  outerCircle.setAttribute('stroke', defaultColor);
  outerCircle.setAttribute('stroke-width', '2');

  // Inner circle
  const innerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  innerCircle.setAttribute('cx', '12');
  innerCircle.setAttribute('cy', '12');
  innerCircle.setAttribute('r', '3');
  innerCircle.setAttribute('fill', defaultColor);

  svg.appendChild(outerCircle);
  svg.appendChild(innerCircle);
  div.appendChild(svg);

  const sprite = new CSS2DObject(div);
  sprite.center.set(0.5, 0.5);

  // Add hover functionality
  sprite.userData.isHovered = false;
  sprite.userData.updateColor = (isHovered) => {
    sprite.userData.isHovered = isHovered;
    const color = isHovered ? hoverColor : defaultColor;
    outerCircle.setAttribute('stroke', color);
    innerCircle.setAttribute('fill', color);
  };

  return sprite;
};
